"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ELEMENT: 1,
  TEXT: 3,
  COMMENT: 8
};


//////////////////
// WEBPACK FOOTER
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/node_modules/html2react/lib/node-type.js
// module id = 492
// module chunks = 0